module.exports = __webpack_public_path__ + "media/svg/ge-88686223.svg";